export default {"src":"/_next/static/media/Question-Mark-animation.bee20a2f.gif","height":1084,"width":1930};